import { Grid } from '@mui/joy';
import { useParams } from 'react-router-dom';
import { EventDetailContentRight } from './EventDetailContentRight';
import { EventDetailMainContent } from './EventDetailMainContent';
import { EventInfoCard } from './EventInfoCard';

const EventDetailIndex = () => {
  const { eventId } = useParams<{
    eventId: string;
  }>();

  if (!eventId) {
    // This should never happen
    return null;
  }

  return (
    <Grid container spacing={3} padding={'1rem'}>
      <Grid xs={12} lg={3}>
        <EventInfoCard eventID={eventId} />
      </Grid>
      <Grid xs={12} lg={6}>
        <EventDetailMainContent eventId={eventId} />
      </Grid>
      <Grid
        xs={0}
        lg={3}
        display={{
          xs: 'none',
          lg: 'block',
        }}
      >
        <EventDetailContentRight eventId={eventId} />
      </Grid>
    </Grid>
  );
};

export default EventDetailIndex;
